import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { GenerationsView } from "../features/generation/index.ts";

export const Generations: FC = () => (
  <PageContainer>
    <GenerationsView />
  </PageContainer>
);
